import { strings } from "./Language";

export default function UserCard({ user, red }) {
  return (
    <div className={'card' + (red ? ' borderRed' : '')}>
      <div className="card-body">
        <div className='row'>
          <button className="printer no-print" onClick={() => window.print()}><i className="icon-printer"></i></button>
          <div className='col-6-print'>
            <div className="centered">
            <h1 className={'blue vip margTop10'}>{user.entranceType}</h1>
              {user.vip ?
                <h2 className={'blue vip margTop10'}>{strings('visited.vip')}</h2>
                : <h2></h2>
               }
              <h4 className={(red ? 'red' : '') + (user.vip ? ' margTop10' : '')}>{user.name} {user.lastName}</h4>
              <p className="subtitle">{user.business}</p>
              <p className="subtitle margBot20">{user.profesion}</p>
            </div>
          </div>

          <div className='col-6-print textRight only-print'>
            {user.qrCode ?
              <img src={user.qrCode} alt='QR' className='qrCode' />
              :
              null
            }
          </div>
        </div>

        <div className="row no-print">
          <div className="col-sm-3 label">
            {strings('common.email')}
          </div>
          <div className="col-sm-9 text-secondary">
            {user.email}
          </div>
        </div>
        <hr />
        <div className="row no-print">
          <div className="col-sm-3 label">
            {strings('common.phone')}
          </div>
          <div className="col-sm-9 text-secondary">
            {user.phone}
          </div>
        </div>
        <hr />
        <div className="row no-print">
          <div className="col-sm-3 label">
            {strings('common.country')}
          </div>
          <div className="col-sm-9 text-secondary">
            {user.country}
          </div>
        </div>
        <hr />
        <div className="row no-print">
          <div className="col-sm-3 label">
            {strings('common.sector')}
          </div>
          <div className="col-sm-9 text-secondary">
            {user.businessSectorName}
          </div>
        </div>
        {/* <hr />
        <div className="row">
          <div className="col-sm-3 label">
            {strings('common.speciality')}
          </div>
          <div className="col-sm-9 text-secondary">
            {user.businessSpecialityNames}
          </div>
        </div> */}
        {user.workshops?.length > 0 ?
          [<hr key='separator' />,
          <div key='workshops' className="row no-print">
            <div className="col-sm-3 label">
              {strings('menu.workshops')}
            </div>
            <div className="col-sm-9 text-secondary">
              <ul>
                {user.workshops.map((workshop, index) =>
                  <li key={index}>{workshop.name}</li>
                )}
              </ul>
            </div>
          </div>]
          :
          null}
      </div>
    </div>
  );
}

